import { forwardRef } from "react";
import { Link } from "react-router-dom";

type Props = {
  password: string;
  onChange: (v: string) => void;
  error: string | null;
  forgotPasswordTo: string;
};

export const PasswordField = forwardRef<HTMLInputElement, Props>(
  ({ password, onChange, error, forgotPasswordTo }, ref) => (
    <div className="signin-field">
      <div className="signin-field-label-row">
        <label className="signin-field-label" htmlFor="signin-password">
          Password
        </label>
        <Link className="signin-forgot" to={forgotPasswordTo}>
          Forgot password?
        </Link>
      </div>
      <input
        ref={ref}
        id="signin-password"
        className="signin-field-input"
        type="password"
        autoComplete="current-password"
        placeholder="••••••••"
        value={password}
        onChange={(e) => onChange(e.target.value)}
        required
      />
      {error && <div className="signin-error">{error}</div>}
    </div>
  ),
);
PasswordField.displayName = "PasswordField";
